import {
  StyleSheet,
} from "react-native";
import { fonts } from "../../../styles/theme";

const PropertyMapsStyle = StyleSheet.create({
  infoWindowContainer: {
    width: '100%', // Set a fixed width for the InfoWindow
    padding: 10, // Add some padding for better spacing
  },
  table: {
    width: "100%",
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "space-between", // Align label and value
    marginBottom: 5,
  },
  tableLabel: {
    fontWeight: "bold",
    color: "#333",
    flex: 1, // Adjust label width for better alignment
    fontFamily: fonts.regular,
  },
  tableValue: {
    flex: 1, // Allow value to take the remaining space
    textAlign: "right", // Align values to the right
    color: "#555",
    fontFamily: fonts.regular,
  },
  linkContainer: {
    flexDirection: "row",
    justifyContent: "flex-end", // Align icons to the right
  },
  icon: {
    height: 35,
    width: 35,
    marginLeft: 10,
  },
});


export default PropertyMapsStyle;